import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("kps_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Auto-recover from an expired/invalid session instead of failing silently.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/me");
    if (status === 401 && !isAuthCall) {
      const hadToken = !!localStorage.getItem("kps_token");
      localStorage.removeItem("kps_token");
      if (hadToken && !window.location.pathname.startsWith("/login")) {
        sessionStorage.setItem("kps_session_expired", "1");
        window.location.assign("/login?expired=1");
      }
    }
    return Promise.reject(err);
  }
);

export function apiError(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return fallback;
}

export default api;
